import React from "react";
import { ENTRIES } from "../shared/assets/entries";
import { GOLFERS } from "../shared/assets/golfers";
import { PAYOUTS } from "../shared/assets/payouts";

function getPositionNum(golfer) {
    let position = GOLFERS.filter((obj) => obj.name === golfer)[0].position;
    let posQualifier = GOLFERS.filter((obj) => obj.name === golfer)[0].posQualifier;
    let curPosNum=0;
    if (posQualifier === "MC" || posQualifier === "DQ") {
        curPosNum = 55;
    } else {
        curPosNum = position;
    }
    return curPosNum;
}
function getPlayerWinnings(golfer, isFinal) {
    let winnings = 0;
    if (isFinal)
        winnings = GOLFERS.filter((obj) => obj.name === golfer)[0].winnings;
    else
        winnings = PAYOUTS[GOLFERS.filter((obj) => obj.name === golfer)[0].position-1];
    return winnings;
}
function positionComparator(a, b) {
    if (a.avgPos === b.avgPos)
        return nameComparator(a, b)
    else
        return a.avgPos - b.avgPos;
}
function nameComparator(a, b) {
    return a.name.localeCompare(b.name)
}
function winningsComparator(a, b) {
    return b.totWinnings - a.totWinnings;
}

function Standings() {

    const sortByPosition = true;
    const isFinal = true;

    const entries = ENTRIES.map((entry) => {
        let totPos=0;
        let totWinnings = 0;
        for (let i = 0; i<entry.golfers.length; i++) {
            totWinnings += parseInt(getPlayerWinnings(entry.golfers[i], isFinal));
            totPos += getPositionNum(entry.golfers[i]);
        }
        let avgPos = totPos / 5;

        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
        });
        let dollars = formatter.format(totWinnings);
        let obj = {
            "name": entry.name,
            "avgPos": avgPos,
            "totWinnings": totWinnings,
            "dollars": dollars,
            "tiebreaker": entry.tiebreaker,
        }

        return (obj)
    });

    if (isFinal) {
        entries.sort(winningsComparator)
    } else if (sortByPosition) {
        entries.sort(positionComparator)
    } else {
        entries.sort(nameComparator);
    }

    const entriesSorted = entries.map((entry, index) => {
        let pos = 0
        // Tie for 1st
        if (index === 1)
            pos = 1
        else
            pos = index + 1

        // console.log(entry.name + ": " + entry.totWinnings);
        return (
            <div className="grid grid-cols-5 m-2 pr-4" key={entry.name}>
                <span className="col-span-1">{pos}</span>
                <span className="place-self-start col-span-2">{entry.name}</span>
                <span className="col-span-1">{entry.tiebreaker}</span>
                <span className="col-span-1">{entry.dollars}</span>
            </div>
        )
    });
    return (
        <div className="flex flex-col lg:w-4/12 w-100 items-center xbg-pink-200">
            <div className="bg-gray-300 mt-14 rounded-lg pb-4">
                <p className="text-3xl my-6 bg-masters-green masters-label">Standings</p>
                <div className="grid grid-cols-5 m-1 font-bold pr-4">
                    <span className="col-span-1">Rank</span>
                    <span className="place-self-start col-span-2">Name</span>
                    <span className="col-span-1">Tie-breaker</span>
                    <span className="col-span-1">*Winnings</span>
                </div>
                {entriesSorted}
            </div>
        </div>
    );
}

export default Standings;